import { useSelector } from 'react-redux';
import { AnimatedScale } from '../../../../shared/ui/animated-container/AnimatedScale';

import s from './TextAdjust.module.css';
import {
    selectActivePrompt,
    selectActiveSettingsSlider,
} from '../../../../store/selectors/pageSelectors';
import { useAppDispatch } from '../../../../store/store';
import { setActiveSettingsSlider } from '../../../../store/slices/pageSlice';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import React, { useEffect, useRef } from 'react';
import IconFonts from '../../../../shared/ui/icons/IconFonts';
import IconTextStyle from '../../../../shared/ui/icons/IconTextStyle';
import IconTextSize from '../../../../shared/ui/icons/IconTextSize';
import IconTextColor from '../../../../shared/ui/icons/IconTextColor';
import { AnimatedContainer } from '../../../../shared/ui/animated-container/AimatedContainer';

const Icons = {
    fonts: <IconFonts width={18} height={18} />,
    style: <IconTextStyle width={18} height={18} />,
    size: <IconTextSize width={18} height={18} />,
    color: <IconTextColor width={18} height={18} />,
};
type SettingKey = keyof typeof Icons;

const labels = {
    fonts: 'Fonts',
    style: 'Style',
    size: 'Size',
    color: 'Color',
};
const TextToolPanel = () => {
    const activePrompt = useSelector(selectActivePrompt);
    const activeSlider = useSelector(selectActiveSettingsSlider);
    const dispatch = useAppDispatch();

    const toolsRef = useRef<(HTMLDivElement | null)[]>([]);
    const indicatorRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const toolKeys = Object.keys(labels);
        const activeIndex = toolKeys.findIndex((key) => key === activeSlider);
        const activeTool = toolsRef.current[activeIndex];
        const indicator = indicatorRef.current;

        if (activeTool && indicator && activeSlider) {
            const toolRect = activeTool.getBoundingClientRect();
            const containerRect = activeTool.parentElement?.getBoundingClientRect();

            if (containerRect) {
                const offsetLeft = toolRect.left - containerRect.left;
                const width = toolRect.width;
                const height = toolRect.height;

                indicator.style.transform = `translateX(${offsetLeft}px)`;
                indicator.style.width = `${width}px`;
                indicator.style.height = `${height}px`;
                indicator.style.opacity = '1';
            }
        } else if (indicator) {
            indicator.style.opacity = '0';
        }
    }, [activeSlider]);

    if (activePrompt != 'add_text') return null;
    return (
        <AnimatedContainer className={s.text_adjust_container}>
            <div className={s.text_adjust_container_inner}>
                <div className={s.toolsWrapper}>
                    <div className={s.activeIndicator} ref={indicatorRef}></div>
                    {Object.entries(labels).map(([key, label], index) => {
                        const isActive = key === activeSlider;
                        const Icon = Icons[key as SettingKey];
                        const iconWithColor = React.cloneElement(Icon, {
                            ...(isActive ? { color: 'black' } : {}),
                        });
                        return (
                            <div
                                key={key}
                                ref={(el) => (toolsRef.current[index] = el)}
                                className={s.tool_item}
                                onClick={() => dispatch(setActiveSettingsSlider(key as SettingKey))}
                                data-tooltip-id={String(key)}
                            >
                                {iconWithColor}
                                <ReactTooltip
                                    id={String(key)}
                                    place="bottom"
                                    content={label as unknown as string}
                                    className={s.tooltip}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        </AnimatedContainer>
    );
};

export default TextToolPanel;
